module.exports = __webpack_public_path__ + "img/smiley_1.0fd402ea.png";